import PATHS from 'utils/paths';

import {
	faBook,
	faChartLine,
	faCubes,
	faHouseChimney,
	faKeySkeleton,
	faLanguage,
	faTree,
	faUsers,
	faWavePulse
} from '@fortawesome/pro-regular-svg-icons';

export const settingsSidebarConfig = [
	{
		header: 'account',
		links: [
			{
				path: PATHS.USER_SETTINGS,
				title: 'myProfile',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/user-icon.json.gz'
			},
			{
				path: PATHS.GENERAL_SETTINGS,
				title: 'company',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/company-icon.json.gz'
			},
			{
				path: PATHS.SECURITY_SETTINGS,
				title: 'security',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/security-icon.json.gz'
			},
			{
				path: PATHS.LOCALIZATION_SETTINGS,
				title: 'configuration',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/configuration-icon-new.json.gz'
			},
			{
				path: PATHS.PAYMENT_NAMAGEMENT,
				title: 'paymentManagement',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/manage-subscription-icon.json.gz'
			},
			{
				path: PATHS.REFERRALS,
				title: 'referrals',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/referral-icon.json.gz'
			},
			{
				path: PATHS.NOTIFICATION_SETTINGS,
				title: 'notification',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/notification-icon.json.gz'
			}
		]
	},
	{
		header: 'payments',
		links: [
			{
				path: PATHS.MANAGE_SUBSCRIPTION,
				title: 'manageSubscription',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/manage-subscription-icon.json.gz'
			},
			{
				path: PATHS.COD_WALLET,
				title: 'CODWallet',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/cod2-dashboard-icon.json.gz'
			},
			{
				path: PATHS.PAYMENTS,
				title: 'transactions',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz'
			},
			{
				path: PATHS.INVOICES,
				title: 'invoices',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/manage-subscription-icon.json.gz'
			}
		]
	},
	{
		header: 'management',
		links: [
			{
				id: 'WarehousesLink',
				path: PATHS.WAREHOUSES,
				title: 'warehouses',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/warehouse-icon.json.gz'
			},
			{
				path: PATHS.PICKUP_LOCATION,
				title: 'senderLocations',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/localization-icon.json.gz'
			},
			{
				path: PATHS.BRANCHES,
				title: 'branches',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/branch-icon.json.gz'
			},
			{
				path: PATHS.USERS,
				title: 'users',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/users-icon.json.gz'
			},
			{
				path: PATHS.ROLE_TEMPLATES,
				title: 'roleTemplates',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Role-Templates-New.json.gz'
			},
			{
				path: PATHS.PRODUCTS_MAIN,
				title: 'products',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/product-icon.json.gz'
			},
			{
				path: PATHS.BOX_SETTINGS,
				title: 'boxes',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/boxes-icon.json.gz'
			},

			{
				path: PATHS.PRINT_SETTINGS,
				title: 'print',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/print-icon.json.gz'
			},
			{
				path: PATHS.BRANDS,
				title: 'brands',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/brand-icon.json.gz'
			}
		]
	},
	{
		header: 'customerNotifs',
		links: [
			{
				path: PATHS.CUSTOMIZABLE_PAGES,
				title: 'customizablePages',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/customizable-pages-icon.json.gz'
			},
			{
				path: `${PATHS.SMS_PROVIDERS}`,
				title: 'smsProviders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/SMS-Provider.json.gz'
			},
			{
				path: PATHS.SMS_SETTINGS,
				title: 'sms',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/sms-icon-new.json.gz'
			},
			{
				path: PATHS.EMAIL,
				title: 'email',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/email-icon.json.gz'
			},
			{
				path: PATHS.WHATSAPP,
				title: 'whatsapp.title',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/whatsapp-icon-new.json.gz'
			}
		]
	},
	{
		header: 'dataCenter',
		links: [
			{
				path: PATHS.IMPORT_LOGS,
				title: 'importLogs',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Import-New.json.gz'
			},
			{
				path: PATHS.EXPORT_LOGS,
				title: 'exportLogs',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Export-New.json.gz'
			}
		]
	},
	{
		header: 'advanced',
		links: [
			{
				path: PATHS.REASON,
				title: 'reasonConfig',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reasonConfig-icon.json.gz'
			},
			{
				path: PATHS.AREA,
				title: 'area',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/area-icon.json.gz'
			},
			{
				path: PATHS.SHIPPING_PRICE,
				title: 'shippingPrices',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/shippingPrices-icon.json.gz'
			},
			{
				path: PATHS.BLACKLISTED_CUSTOMERS,
				title: 'blacklistedCustomer',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/blacklistedCustomer-icon.json.gz'
			},
			{
				path: PATHS.ORDER_AUTOMATION,
				title: 'orderOtomation',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/border/order-otomation.json.gz'
			},
			{
				path: PATHS.SHIPPING_AUTOMATION,
				title: 'shippingOtomation',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/automation-icon.json.gz'
			},

			{
				path: PATHS.AUTOCORRECTOR,
				title: 'autocorrector',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Autocorrectornew.json.gz'
			},
			{
				path: PATHS.AUTOMATION,
				title: 'automation',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/automation-icon.json.gz'
			}
		]
	},
	{
		header: 'developers',
		links: [
			{
				path: PATHS.API_INTEGRATIONS,
				title: 'apiIntegrations',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/oto-api.json.gz'
			},
			{
				path: 'https://apis.tryoto.com/',
				role: '/api-documentation',
				title: 'apiDocumentation',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/API-Documentation.json.gz',
				external: true
			},
			{
				path: PATHS.WEBHOOKS,
				title: 'webhooks',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Webhooks.json.gz'
			}
		]
	},
	{
		header: 'logs',
		links: [
			{
				path: PATHS.SYSTEM_LOGS,
				title: 'systemLogs',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/systemLogs.json.gz'
			},
			{
				path: PATHS.INTEGRATION_LOGS,
				title: 'integrationLogs',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Integration-Logs-New.json.gz'
			},
			{
				path: PATHS.NOTIFICATION_LOGS,
				title: 'notificationLogs',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/notificationLogs.json.gz'
			}
		]
	}
];

export const sideBarConfig = [
	{
		links: [
			{
				path: PATHS.HOME,
				title: 'home',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/home-new-icon.json.gz'
			}
		]
	},
	{
		header: 'dashboard',
		links: [
			{
				icon: faChartLine,
				path: PATHS.COHORT_ANALYSIS,
				title: 'cohortAnalysis'
			},
			{
				path: PATHS.COMPANY_KPI_DASHBOARD,
				title: 'companyKPIDashboard',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/dashboard-icon-new.json.gz'
			},
			{
				path: PATHS.UNIT_ECONOMICS_DASHBOARD,
				title: 'unitEconomicsDashboard',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/dashboard-icon-new.json.gz'
			}
		]
	},
	{
		header: 'customerSupport',
		links: [
			{
				icon: faUsers,
				path: PATHS.CLIENT_LISTING,
				title: 'clientListing'
			},
			{
				path: PATHS.CLIENT_USERS,
				title: 'support.clientUsers',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/configuration-icon.json.gz'
			}
		]
	},
	{
		header: 'systemAdmin',
		links: [
			{
				icon: faUsers,
				path: PATHS.ACCESS_CONTROL,
				title: 'accessControl'
			},
			{
				icon: faTree,
				path: PATHS.ROLE_TREE,
				title: 'roleTree'
			},
			{
				icon: faKeySkeleton,
				path: PATHS.ENUM_MANAGEMENT,
				title: 'enumManagement'
			},
			{
				icon: faBook,
				path: PATHS.STORY_MANAGEMENT,
				title: 'storyManagement'
			},
			{
				icon: faLanguage,
				path: PATHS.LANGUAGE_RESOURCE_MANAGEMENT,
				title: 'languageResourceManagement'
			}
		]
	},
	{
		header: 'warehouse',
		links: [
			{
				path: PATHS.WH_DASHBOARD,
				title: 'dashboard',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/dashboard-icon-new.json.gz'
			},
			{
				path: PATHS.WH_PENDING_ORDERS,
				title: 'pendingOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/pendingOrders-icon.json.gz'
			},
			{
				path: PATHS.WH_WAITING_PICKUP,
				title: 'waitingPickup',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/waitingPickup-icon.json.gz'
			},
			{
				path: PATHS.WH_SHIPMENT_INPROGRESS,
				title: 'shipmentInProgress',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/shipmentInProgress-icon.json.gz'
			},
			{
				path: PATHS.WH_SHIPMENT_ONHOLD,
				title: 'shipmentOnHold',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/shipmentOnHold-icon.json.gz'
			},
			{
				path: PATHS.WH_HISTORY,
				title: 'history',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/orderHistory-icon.json.gz'
			}
		]
	},
	{
		header: 'branch',
		links: [
			{
				path: PATHS.BR_DASHBOARD,
				title: 'dashboard',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/dashboard-icon-new.json.gz'
			},
			{
				path: PATHS.BR_PENDING_ORDERS,
				title: 'pendingOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/pendingOrders-icon.json.gz'
			},
			{
				path: PATHS.BR_WAITING_FOR_DRIVER,
				title: 'waitingDriver',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/waitingDriver-icon.json.gz'
			},
			{
				path: PATHS.BR_SHIPMENT_IN_PROGRESS,
				title: 'shipmentInProgress',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/shipmentInProgress-icon.json.gz'
			},
			{
				path: PATHS.BR_DELIVERED,
				title: 'deliveredOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/deliveredOrders-icon.json.gz'
			},
			{
				path: PATHS.BR_CANCELED,
				title: 'canceledOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/canceledOrders-icon.json.gz'
			},
			{
				path: PATHS.BR_RETURNED,
				title: 'returnedOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/returnedOrders-icon.json.gz'
			},
			{
				path: PATHS.BR_UNASSINGED,
				title: 'unassignedOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/unassignedOrders-icon.json.gz'
			}
		]
	},
	{
		header: 'driver',
		links: [
			{
				path: PATHS.DR_HOME,
				title: 'home',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/home-new-icon.json.gz'
			}
		]
	},
	{
		header: 'deliveryPriceSystem',
		links: [
			{
				path: PATHS.CONTRACT_CONFIGURATIONS,
				title: 'contractConfigurations',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reasonConfig-icon.json.gz'
			},
			{
				path: PATHS.PRICE_CONFIGURATIONS,
				title: 'priceConfigurations',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/calculator-icon-new.json.gz'
			},
			{
				path: PATHS.SLA_CONFIGURATIONS,
				title: 'slaConfigurations',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/otoFlex-icon.json.gz'
			},
			{
				path: PATHS.INVOICE_CHECKER,
				title: 'invoiceChecker',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importExport-icon.json.gz'
			}
		]
	},
	{
		header: 'shipping',
		links: [
			{
				path: PATHS.SHIPMENTS,
				title: 'shipments',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shipments-icon-new.json.gz'
			},
			{
				path: PATHS.FOODICS_SHIPMENTS,
				title: 'foodicsShipments',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shipments-icon-new.json.gz'
			},
			{
				path: PATHS.PRICE_CALCULATOR,
				title: 'priceCalculator',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/calculator-icon-new.json.gz'
			},
			{
				path: PATHS.OTO_LINK,
				badge: 'tag.beta',
				title: 'otoLink',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/oto-link-icon.json.gz'
			},
			{
				path: PATHS.OTO_STORE,
				title: 'otoStore',
				badge: 'new',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/oto-store.json.gz'
			},
			{
				path: PATHS.CUSTOMER_SERVICE,
				title: 'customerService',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/customerService-icon.json.gz'
			},
			{
				path: PATHS.PROCESSING_ORDERS,
				title: 'processingOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/processingOrders-icon.json.gz'
			},
			{
				path: PATHS.HISTORY_ORDERS,
				title: 'historyOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/orderHistory-icon.json.gz'
			},
			{
				path: PATHS.OPERATION_SHIPMENT,
				title: 'allOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shipments-icon-new.json.gz'
			},
			{
				path: PATHS.BULLET_TRACKING,
				title: 'bulletTrackingList',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shipments-icon-new.json.gz'
			},
			{
				path: PATHS.PICKUP_REQUESTS,
				title: 'pickupRequests',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			}
		]
	},
	{
		header: 'importOrdersHeader',
		badge: 'new',
		links: [
			{
				path: PATHS.IMPORT_ORDERS,
				title: 'importOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/import-plane.json.gz'
			},
			{
				path: PATHS.IMPORT_CALCULATOR,
				title: 'importCalculator',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/get_estimate.json.gz'
			}
		]
	},
	{
		header: 'performance',
		links: [
			{
				path: PATHS.DASHBOARD,
				title: 'dashboard',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/dashboard-icon-new.json.gz'
			},
			{
				path: PATHS.ANALYSIS,
				title: 'analysis',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/analysis-icon-new.json.gz'
			},
			{
				path: PATHS.REPORTS,
				title: 'reports',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			},
			{
				path: PATHS.AGGREGATOR_DC_PERFORMANCE,
				title: 'DCPerformance',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			},
			{
				path: PATHS.AGGREGATOR_AGING,
				title: 'AggregatorAging',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			},
			{
				path: PATHS.ZERO_DC,
				title: 'ZeroDCResults',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			},
			{
				path: PATHS.MISSING_MAPPING_STATUSES,
				title: 'missingMappingStatuses',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			},
			{
				path: PATHS.CREATE_SHIPMENT_ERROR_MAPPING,
				title: 'shipmentErrorMapping',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			},
			{
				path: PATHS.FOODICS_SHIPPING_TRANSACTION,
				title: 'shippingTransaction',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
			}
		]
	},
	{
		header: 'integrations',
		links: [
			{
				path: PATHS.SALES_CHANNELS,
				title: 'salesChannel',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/salesChannels-icon-a-new.json.gz'
			},
			{
				path: PATHS.SHIPPING_PARTNERS,
				title: 'shippingPartners',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shippingPartners-icon-new.json.gz'
			}
		]
	},
	{
		header: 'otoPack',
		links: [
			{
				path: PATHS.WMS_CONFIGURATION,
				title: 'wms.configuration',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/configuration-icon.json.gz'
			},
			{
				path: PATHS.INVENTORY_MAIN,
				title: 'inventory',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Inventory-new.json.gz'
			},
			{
				icon: faWavePulse,
				path: PATHS.WAVES,
				title: 'waves'
			},
			{
				path: PATHS.OPERATIONS,
				title: 'operations',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/operations-icon-new.json.gz'
			},
			{
				path: PATHS.PURCHASE_ORDERS,
				title: 'purchaseOrders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/inventory-icon.json.gz'
			}
		]
	},
	{
		header: 'otoFlex',
		links: [
			{
				path: PATHS.DRIVERS,
				title: 'drivers',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/OTO-Flex-Driver-new.json.gz'
			},
			{
				path: PATHS.OTO_FLEX_MAIN,
				title: 'orders',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/oto-flex-order.json.gz'
			}
		]
	},
	{
		header: 'brand',
		links: [
			{
				path: PATHS.BM_PRODUCTS,
				title: 'product',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/product-icon.json.gz'
			},
			{
				path: PATHS.BM_ORDERS,
				title: 'orders',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/orders-icon.json.gz'
			},
			{
				path: PATHS.BM_INVENTORY,
				title: 'inventory',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/inventory-icon.json.gz'
			}
		]
	},
	{
		header: 'payments',
		links: [
			{
				path: PATHS.TRANSACTIONS,
				title: 'clientTransactions',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz'
			},
			{
				icon: faUsers,
				path: PATHS.SUBSCRIPTION,
				title: 'subscriptions'
			},
			{
				path: PATHS.EXTRA_CREDITS,
				title: 'extraCredits',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/brand-icon.json.gz'
			},
			{
				path: PATHS.BANK_TRANSFER,
				title: 'bankTransfer',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz'
			},
			{
				path: PATHS.OTO_LINK_FINANCE_TRANSACTIONS,
				title: 'otoLinkTransactions',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz'
			},
			{
				path: PATHS.PROMOTIONS,
				title: 'promoCodes',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importExport-icon.json.gz'
			},
			{
				path: PATHS.REFERRAL_LIST,
				title: 'referals',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/referral-icon.json.gz'
			},
			{
				path: PATHS.OTO_INVOICE_LOGS,
				title: 'otoInvoiceLogs',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logs-icon.json.gz'
			}
		]
	},
	{
		header: 'financeAdmin',
		links: [
			{
				path: PATHS.COD_PAYABLE,
				title: 'CODPayable',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logs-icon.json.gz'
			},
			{
				path: PATHS.COD_RECEIVABLES,
				title: 'CODReceivables',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logs-icon.json.gz'
			},
			{
				path: PATHS.COD_WALLET_TRANSACTIONS,
				title: 'CODWalletTransactions',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logs-icon.json.gz'
			}
		]
	},
	{
		header: 'deliveryCompanyModule',
		links: [
			{
				path: PATHS.DELIVERY_COMPANIES,
				title: 'deliveryCompanies',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reasonConfig-icon.json.gz'
			},
			{
				icon: faCubes,
				path: PATHS.DELIVERY_COMPANY_MODULE,
				title: 'dcSettings'
			},
			{
				path: PATHS.DC_PICKUP_LOCATION,
				title: 'dcPickupLocation',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shippingPartners-icon-new.json.gz'
			},
			{
				path: PATHS.DC_STATUS_MANAGEMENT,
				title: 'dcStatusManagement',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shippingPartners-icon-new.json.gz'
			}
		]
	},
	{
		header: 'configurations',
		links: [
			{
				path: PATHS.ADMIN_SALES_CHANNELS,
				title: 'salesChannels',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shippingPartners-icon-new.json.gz'
			},
			{
				path: PATHS.PACKAGES,
				title: 'packages',
				lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/boxes-icon.json.gz'
			},
			{
				icon: faCubes,
				path: PATHS.OTHER_INTEGRATIONS_LIST,
				title: 'otherIntegrationsList'
			},
			{
				path: PATHS.BANKS,
				title: 'banks',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz'
			},
			{
				path: PATHS.ADDRESS_MANAGEMENT,
				title: 'addressManagement',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/localization-icon.json.gz'
			},
			{
				path: PATHS.ADMIN_COUNTRIES_MANAGEMENT,
				title: 'countries',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/localization-icon.json.gz'
			},
			{
				icon: faHouseChimney,
				path: PATHS.HOME_PAGE_ANNOUNCEMENTS_MANAGEMENT,
				title: 'homePageAnnouncementsManagement',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/localization-icon.json.gz'
			},
			{
				icon: faCubes,
				path: PATHS.OTO_AI_CLIENT_CONFIGURATION,
				title: 'otoAIClientConfiguration',
				lordIcon:
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/localization-icon.json.gz'
			}
		]
	}
];

export const profileConfig = [
	{
		path: PATHS.USER_SETTINGS,
		title: 'myProfile',
		lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/user-icon.json.gz'
	},
	{
		action: 'changeTheme',
		title: 'darkTheme',
		lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/darkTheme-icon.json.gz'
	},
	{
		action: 'changeTheme',
		title: 'lightTheme',
		lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/lightTheme-icon.json.gz'
	},
	{
		path: PATHS.LOGOUT,
		title: 'logout',
		lordIcon: 'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logout-icon.json.gz'
	}
];
